import React from 'react';
import { Box, Icon, Tooltip, keyframes, useColorModeValue } from '@chakra-ui/react';
import { ChatIcon } from '@chakra-ui/icons';

const pulseRing = keyframes`
  0% { transform: scale(0.33); opacity: 1; }
  80%, 100% { transform: scale(2.5); opacity: 0; }
`;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

function FloatingContactButton() {
    const bgColor = useColorModeValue('brand.500', 'brand.400');

    return (
        <Box
            position="fixed"
            bottom="40px"
            right="40px"
            zIndex="tooltip"
            animation={`${float} 4s ease-in-out infinite`}
        >
            <Tooltip label="Contact DataRunk" placement="left" hasArrow bg="gray.800" color="white" fontSize="md" p={2} borderRadius="md">
                <Box
                    as="a"
                    href="https://datarunk.com/contato/"
                    target="_blank"
                    rel="noopener noreferrer"
                    position="relative"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    width="64px"
                    height="64px"
                    bgGradient="linear(to-r, brand.400, brand.600)"
                    color="white"
                    borderRadius="full"
                    boxShadow="0 4px 20px rgba(0, 0, 0, 0.3)"
                    cursor="pointer"
                    transition="all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)"
                    _hover={{
                        transform: 'scale(1.1) rotate(5deg)',
                        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.4)',
                    }}
                    _before={{
                        content: "''",
                        position: 'absolute',
                        display: 'block',
                        width: '300%',
                        height: '300%',
                        boxSizing: 'border-box',
                        marginLeft: '-100%',
                        marginTop: '-100%',
                        borderRadius: '50%',
                        bgColor: bgColor,
                        animation: `${pulseRing} 2.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite`,
                        opacity: 0.6,
                        zIndex: -1,
                    }}
                >
                    <Icon as={ChatIcon} w={7} h={7} />
                </Box>
            </Tooltip>
        </Box>
    );
}

export default FloatingContactButton;
